<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=550 content-class="round-2xl")
  v-card
    div.py-6.px-10
      div.mb-4 Some error occurred while adding the following medicines:
      div.my-2(v-for="(errorItem, index) in errorItems" :key="index")
        div.text-sm Item name : 
          span.font-semibold {{ errorItem.item.productItem.name }}
        div.text-xs.danger500--text {{ getErrorMessage(errorItem) }}
        v-divider.my-2(v-if="index !== errorItems.length - 1")
    v-divider
    v-card-actions.px-6
      v-spacer
      v-btn.button-md.neutral700--text.px-0.underline(text @click="closeDialog") {{ $t('close') }}
</template>

<script>

export default {
  name: 'DeleteConfirmationDialog',
  props: {
    open: {
      type: Boolean,
    },
    errorItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog () {
      this.$emit('cancel')
      this.showDialog = false
    },
    getErrorMessage ({ error }) {
      if (error.response?.status === 400 && error.response?.data?.code === '444101') {
        return 'Item quantity more than available stock. Please try using single item selection'
      }

      return error.message ?? 'Unknown error occurred. Please try using single item selection'
    }
  },
}
</script>